'use client';

import { c as _c } from "react/compiler-runtime";
import { useIsClient } from 'usehooks-ts';
import ViverseWorldCardBanner from '@/components/ViverseWorldCardBanner';
import ViverseWorldCardDefault from '@/components/ViverseWorldCardDefault';
import { WorldCardProvider } from '@/context/ViverseWorldCardContext';
import { extractRoomIdFromUrl } from '@/lib/cms';
import { isNewRoom, isUpdatedRoom } from '@/lib/viverse-world-card';
import roomDefaultImage from '@/public/images/room-default.png';
import { ViverseWorldCardProps } from '@/types/viverse-world-card';
export default function ViverseWorldCard(t0) {
  const $ = _c(87);
  let banner;
  let className;
  let customDesc;
  let href;
  let imageClassName;
  let imageSizes;
  let info;
  let isExclusive;
  let isHot;
  let isNew;
  let isSelected;
  let isTop;
  let isUpdated;
  let mediaClassName;
  let moreActionContent;
  let noAccess;
  let onAfterMutatingWorld;
  let priority;
  let props;
  let rankingIndex;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    ({
      href,
      info,
      showMoreAction: t1,
      moreActionContent,
      customDesc,
      hideLiked: t2,
      shareOnly: t3,
      isCoOwnedRoom: t4,
      className,
      imageClassName,
      mediaClassName,
      imageSizes,
      onAfterMutatingWorld,
      stopSetAsFeatured: t5,
      hidePremiumBadge: t6,
      ranking: t7,
      rankingIndex,
      cardOnly: t8,
      isNew,
      isUpdated,
      isMission: t9,
      isExclusive,
      isSelected,
      isHot,
      isTop,
      isLive: t10,
      forceShowPremiumBadge: t11,
      disableAutoPreview: t12,
      noAccess,
      cardType: t13,
      priority,
      banner,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = banner;
    $[2] = className;
    $[3] = customDesc;
    $[4] = href;
    $[5] = imageClassName;
    $[6] = imageSizes;
    $[7] = info;
    $[8] = isExclusive;
    $[9] = isHot;
    $[10] = isNew;
    $[11] = isSelected;
    $[12] = isTop;
    $[13] = isUpdated;
    $[14] = mediaClassName;
    $[15] = moreActionContent;
    $[16] = noAccess;
    $[17] = onAfterMutatingWorld;
    $[18] = priority;
    $[19] = props;
    $[20] = rankingIndex;
    $[21] = t1;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    banner = $[1];
    className = $[2];
    customDesc = $[3];
    href = $[4];
    imageClassName = $[5];
    imageSizes = $[6];
    info = $[7];
    isExclusive = $[8];
    isHot = $[9];
    isNew = $[10];
    isSelected = $[11];
    isTop = $[12];
    isUpdated = $[13];
    mediaClassName = $[14];
    moreActionContent = $[15];
    noAccess = $[16];
    onAfterMutatingWorld = $[17];
    priority = $[18];
    props = $[19];
    rankingIndex = $[20];
    t1 = $[21];
    t10 = $[22];
    t11 = $[23];
    t12 = $[24];
    t13 = $[25];
    t2 = $[26];
    t3 = $[27];
    t4 = $[28];
    t5 = $[29];
    t6 = $[30];
    t7 = $[31];
    t8 = $[32];
    t9 = $[33];
  }
  const showMoreAction = t1 === undefined ? false : t1;
  const hideLiked = t2 === undefined ? false : t2;
  const shareOnly = t3 === undefined ? false : t3;
  const isCoOwnedRoom = t4 === undefined ? false : t4;
  const stopSetAsFeatured = t5 === undefined ? false : t5;
  const hidePremiumBadge = t6 === undefined ? true : t6;
  const ranking = t7 === undefined ? false : t7;
  const cardOnly = t8 === undefined ? false : t8;
  const isMission = t9 === undefined ? false : t9;
  const isLive = t10 === undefined ? false : t10;
  const forceShowPremiumBadge = t11 === undefined ? false : t11;
  const disableAutoPreview = t12 === undefined ? false : t12;
  const cardType = t13 === undefined ? "experiences" : t13;
  const {
    image: t14,
    hubs_url,
    owner,
    is_voucher_room,
    vod_duration,
    vod_last_update_date,
    trailer_videos,
    external_link
  } = info;
  const image = t14 === undefined ? roomDefaultImage.src : t14;
  const isClient = useIsClient();
  let t15;
  if ($[34] !== info.first_public_date || $[35] !== isNew) {
    t15 = isNew ?? isNewRoom(info.first_public_date);
    $[34] = info.first_public_date;
    $[35] = isNew;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  const showNew = t15;
  let t16;
  if ($[37] !== info.first_public_date || $[38] !== info.last_updated_at || $[39] !== isUpdated) {
    t16 = isUpdated ?? isUpdatedRoom(info.last_updated_at, info.first_public_date);
    $[37] = info.first_public_date;
    $[38] = info.last_updated_at;
    $[39] = isUpdated;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  const showUpdated = t16;
  const showExclusive = isExclusive ?? info.is_exclusive ?? false;
  const showSelected = isSelected ?? info.is_selected ?? false;
  const showHot = isHot ?? info.is_hot ?? false;
  const showTop = isTop ?? info.is_top ?? false;
  const showPremiumTag = !!(forceShowPremiumBadge || !hidePremiumBadge && is_voucher_room);
  const isVOD = typeof vod_duration === "number" && !!vod_last_update_date;
  const resolvedImage = noAccess ? roomDefaultImage.src : image;
  const vodId = info.vod_id || trailer_videos?.[0]?.vod_id;
  const t17 = banner?.ctaHref || href || external_link || hubs_url || "/";
  let t18;
  if ($[41] !== t17) {
    t18 = extractRoomIdFromUrl(t17);
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  const targetUrl = t18;
  const title = info.title;
  const imageAlt = title ? owner?.display_name ? `${title} by ${owner.display_name}` : title : "";
  const Card = cardType === "banner" ? ViverseWorldCardBanner : ViverseWorldCardDefault;
  let t19;
  if ($[43] !== banner || $[44] !== cardOnly || $[45] !== cardType || $[46] !== customDesc || $[47] !== disableAutoPreview || $[48] !== hideLiked || $[49] !== href || $[50] !== imageAlt || $[51] !== imageClassName || $[52] !== imageSizes || $[53] !== info || $[54] !== isClient || $[55] !== isCoOwnedRoom || $[56] !== isLive || $[57] !== isMission || $[58] !== isVOD || $[59] !== mediaClassName || $[60] !== moreActionContent || $[61] !== noAccess || $[62] !== onAfterMutatingWorld || $[63] !== priority || $[64] !== ranking || $[65] !== rankingIndex || $[66] !== resolvedImage || $[67] !== shareOnly || $[68] !== showExclusive || $[69] !== showHot || $[70] !== showMoreAction || $[71] !== showNew || $[72] !== showPremiumTag || $[73] !== showSelected || $[74] !== showTop || $[75] !== showUpdated || $[76] !== stopSetAsFeatured || $[77] !== targetUrl || $[78] !== vodId) {
    t19 = {
      targetUrl,
      imageAlt,
      cardType,
      resolvedImage,
      showPremiumTag,
      isVOD,
      vodId,
      href,
      imageClassName,
      mediaClassName,
      imageSizes,
      priority,
      noAccess,
      customDesc,
      moreActionContent,
      hideLiked,
      isCoOwnedRoom,
      showMoreAction,
      shareOnly,
      stopSetAsFeatured,
      onAfterMutatingWorld,
      info,
      isClient,
      disableAutoPreview,
      ranking,
      rankingIndex,
      cardOnly,
      isMission,
      isNew: showNew,
      isUpdated: showUpdated,
      isExclusive: showExclusive,
      isSelected: showSelected,
      isHot: showHot,
      isTop: showTop,
      isLive,
      banner
    };
    $[43] = banner;
    $[44] = cardOnly;
    $[45] = cardType;
    $[46] = customDesc;
    $[47] = disableAutoPreview;
    $[48] = hideLiked;
    $[49] = href;
    $[50] = imageAlt;
    $[51] = imageClassName;
    $[52] = imageSizes;
    $[53] = info;
    $[54] = isClient;
    $[55] = isCoOwnedRoom;
    $[56] = isLive;
    $[57] = isMission;
    $[58] = isVOD;
    $[59] = mediaClassName;
    $[60] = moreActionContent;
    $[61] = noAccess;
    $[62] = onAfterMutatingWorld;
    $[63] = priority;
    $[64] = ranking;
    $[65] = rankingIndex;
    $[66] = resolvedImage;
    $[67] = shareOnly;
    $[68] = showExclusive;
    $[69] = showHot;
    $[70] = showMoreAction;
    $[71] = showNew;
    $[72] = showPremiumTag;
    $[73] = showSelected;
    $[74] = showTop;
    $[75] = showUpdated;
    $[76] = stopSetAsFeatured;
    $[77] = targetUrl;
    $[78] = vodId;
    $[79] = t19;
  } else {
    t19 = $[79];
  }
  let t20;
  if ($[80] !== Card || $[81] !== className || $[82] !== props) {
    t20 = <Card {...props} className={className} />;
    $[80] = Card;
    $[81] = className;
    $[82] = props;
    $[83] = t20;
  } else {
    t20 = $[83];
  }
  let t21;
  if ($[84] !== t19 || $[85] !== t20) {
    t21 = <WorldCardProvider value={t19}>{t20}</WorldCardProvider>;
    $[84] = t19;
    $[85] = t20;
    $[86] = t21;
  } else {
    t21 = $[86];
  }
  return t21;
}